var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/slovakia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/slovakia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slovakia",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C397.384,512 512,397.384 512,256 C512,224.686 506.368,194.689 496.077,166.957 L15.923,166.957 C5.633,194.689 0,224.686 0,256 C0,397.384 114.616,512 256,512 Z",
    id: "Path",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C366.071,512 459.906,442.528 496.077,345.043 L15.923,345.043 C52.094,442.528 145.929,512 256,512 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.198,144.696 L66.198,272.402 C66.198,345.046 161.099,367.305 161.099,367.305 C161.099,367.305 255.999,345.046 255.999,272.402 L255.999,144.696 L66.198,144.696 Z",
    id: "Path",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.459,144.696 L88.459,272.402 C88.459,280.93 90.353,288.984 94.105,296.535 C131.339,296.535 186.991,296.535 228.092,296.535 C231.844,288.985 233.738,280.93 233.738,272.402 L233.738,144.696 L88.459,144.696 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0F0F0",
    points: "205.62 233.739 172.23 233.739 172.23 211.478 194.491 211.478 194.491 189.217 172.23 189.217 172.23 166.957 149.969 166.957 149.969 189.217 127.709 189.217 127.709 211.478 149.969 211.478 149.969 233.739 116.577 233.739 116.577 256 149.969 256 149.969 278.261 172.23 278.261 172.23 256 205.62 256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.471,327.61 C138.816,336.625 153.554,341.859 161.099,344.187 C168.644,341.86 183.382,336.625 197.727,327.61 C212.193,318.518 222.334,308.12 228.092,296.535 C221.741,292.042 213.992,289.392 205.621,289.392 C202.573,289.392 199.612,289.753 196.765,290.416 C190.732,276.708 177.037,267.131 161.1,267.131 C145.163,267.131 131.467,276.708 125.435,290.416 C122.588,289.753 119.626,289.392 116.579,289.392 C108.208,289.392 100.459,292.042 94.108,296.535 C99.863,308.119 110.004,318.517 124.471,327.61 Z",
    id: "Path",
    fill: "#0052B4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.87f341f57a2e4931bfda8b44a58ff044.svg";
export { ForwardRef as ReactComponent };